import { useSubscribers } from '../../../../../store/subscription/useSubscribers'

export function SubscriptionDetailsPause() {
  const details = useSubscribers(state => state.data.details)
  if (!details) return null
  const { pauseHistory = [] } = details
  if (!pauseHistory.length) {
    return (
      <section className="space-y-4 p-4" aria-label="Pausas da assinatura">
        <p>Nenhuma pausa registrada.</p>
      </section>
    )
  }
  return (
    <section className="space-y-4 p-4" aria-label="Pausas da assinatura">
      {!!pauseHistory.length && (
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left">
            <thead><tr>{['Plano', 'Dias', 'Início', 'Término', 'Cobrança anterior', 'Nova cobrança', 'Status'].map(label => <th key={label} scope="col" className="p-2">{label}</th>)}</tr></thead>
            <tbody>{pauseHistory.map(item => <tr key={item.id} className="border-t border-gray-200">
              <td className="p-2">{item.planType}</td><td className="p-2">{item.days ?? '—'}</td>
              <td className="p-2">{item.startedAt}</td><td className="p-2">{item.endedAt}</td>
              <td className="p-2">{item.previousBillingAt}</td><td className="p-2">{item.nextBillingAt}</td>
              <td className="p-2">{item.state}</td>
            </tr>)}</tbody>
          </table>
        </div>
      )}
      <p className="text-sm">Datas e horários de Brasília. Histórico anterior depende dos registros disponíveis.</p>
    </section>
  )
}
